import React from 'react'
import { PrismicRichText} from '@prismicio/react'

const WebContent = ({ content, resource_type }) => {
    if(content !== null){
      return (
        <PrismicRichText field={content.raw} components={{
          heading2: ({children}) => <h2 className="h3 mt-lg-4">{children}</h2>,
          heading3: ({children}) => <h3 className="h4 mt-lg-4">{children}</h3>,
          heading4: ({children}) => <h4 className="h5 mt-lg-3">{children}</h4>,
          heading5: ({children}) => <h5 className="h6 mt-lg-3">{children}</h5>,
          paragraph: ({children}) => <p className="mt-lg-3">{children}</p>,
          list: ({children}) => <ul className="web-content-list">{children}</ul>,
          strong: ({children}) => <span className="font-weight-bold">{children}</span>,
          em: ({children}) => <span className="font-italic">{children}</span>,
          image: ({ node, key }) => {
            return (
              <img key={key}
                src={node.url}
                alt={node.alt ?? undefined}
                className="float-left mr-3 mb-2"
                data-copyright={node.copyright ? node.copyright : undefined}
              />
            );
          },
          hyperlink: ({node, children, key}) => {
            <a href={node.url}
              key={key}
              className="animated"
              rel="noopener noreferrer"
            >
              {children}
            </a>
          }
        }}/> 
      ) 
    }
    else {
      if(resource_type === "Document"){
        // return (
        //   <p>For the full content of this item, please see the PDF, which is linked from this page.</p>
        // )
        return null
      }
      else {
        return (
          <p>For the full content of this item, please use the link on this page.</p>
        )
      }
    }
  }

export default WebContent;